import React from 'react';
import { motion } from 'framer-motion';
export function RevealSection() {
  const fadeIn = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: 'easeOut'
      }
    }
  };
  return <motion.section initial="hidden" whileInView="visible" viewport={{
    once: true
  }} variants={fadeIn} className="space-y-10 pt-8 border-t border-[#1B2A4A]/10 mt-12 mb-12" data-id="element-168">
      <p className="font-medium text-xl md:text-2xl text-[#1B2A4A]" data-id="element-169">
        The Social Security Administration has three &quot;Secret
        Exits&quot;—legal, built-in protocols designed for people who realized
        they made a mistake.
      </p>

      <div className="space-y-8" data-id="element-170">
        <div className="flex items-start gap-4 md:gap-5" data-id="element-171">
          <span className="flex-shrink-0 text-4xl md:text-5xl font-bold text-[#D4652A] leading-none mt-1" data-id="element-172">
            1
          </span>
          <div data-id="element-173">
            <h3 className="text-xl md:text-2xl font-bold text-[#1B2A4A] mb-2" data-id="element-174">
              The 12-Month &quot;Time Machine&quot;
            </h3>
            <p className="text-[#1B2A4A]/90 text-lg" data-id="element-175">
              A way to completely wipe your record clean as if you never
              claimed.
            </p>
          </div>
        </div>

        <div className="flex items-start gap-4 md:gap-5" data-id="element-176">
          <span className="flex-shrink-0 text-4xl md:text-5xl font-bold text-[#D4652A] leading-none mt-1" data-id="element-177">
            2
          </span>
          <div data-id="element-178">
            <h3 className="text-xl md:text-2xl font-bold text-[#1B2A4A] mb-2" data-id="element-179">
              The FRA Suspension
            </h3>
            <p className="text-[#1B2A4A]/90 text-lg" data-id="element-180">
              A way to &quot;pause&quot; your check at 66 or 67 to trigger a
              massive 8% annual raise.
            </p>
          </div>
        </div>

        <div className="flex items-start gap-4 md:gap-5" data-id="element-181">
          <span className="flex-shrink-0 text-4xl md:text-5xl font-bold text-[#D4652A] leading-none mt-1" data-id="element-182">
            3
          </span>
          <div data-id="element-183">
            <h3 className="text-xl md:text-2xl font-bold text-[#1B2A4A] mb-2" data-id="element-184">
              The Work-Logic Offset
            </h3>
            <p className="text-[#1B2A4A]/90 text-lg" data-id="element-185">
              How to use a job to &quot;force&quot; the government to give you a
              raise later.
            </p>
          </div>
        </div>
      </div>
    </motion.section>;
}